import Vue from 'vue'
import Router from 'vue-router'
import NotFoundPage from '../pages/NotFound'
import Login from '../pages/login'
import AppIndex from '../pages/AppIndex'
import ApplyIndex from '../pages/apply/index'
// import applyStep1 from '../pages/apply/step1'
// import applyStep2 from '../pages/apply/step2'
// import applyStep3 from '../pages/apply/step3'
import AnchorHome from '../pages/anchor/AnchorHome'
import AnchorManagement from '../pages/anchor/AnchorManagement'
import anchorApprovalPage from '../pages/approval/anchorApprovalPage'
import anchorRevenuesPage from '../pages/revenues/anchorRevenuesPage'
import myGuildDetailPage from '../pages/guild/myGuildDetailPage'
import personalCenterPage from '../pages/guild/personalCenterPage'

Vue.use(Router)

export default new Router({
  linkActiveClass:'linkActive',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/apply',
      name: 'apply-index',
      component: ApplyIndex,
    },
    {
      path: '/',
      component: AppIndex,
      name: 'index',
      children:[
        {
          path: '',
          redirect:'/guild/my-guild-detail',
        },
        {
          path: '/anchor',
          component:AnchorHome,
          redirect:'/anchor/management',
          children:[
            {
              path:'management',
              name:'anchor-management',
              component:AnchorManagement,
            }
          ]
        },
        {
          path: '/approval/anchor-approval',
          name: 'anchorApprovalPage',
          component: anchorApprovalPage,
        },
        {
          path: '/revenues/anchor-revenues',
          name: 'anchorRevenuesPage',
          component: anchorRevenuesPage,
        },
        {
          path: '/guild/my-guild-detail',
          name: 'my-guild-detail-page',
          component: myGuildDetailPage,
        },
        {
          path: '/guild/personal-center-page',
          name: 'personal-center-page',
          component: personalCenterPage,
        },
        {
          path: '*',
          name: 'NotFound',
          component: NotFoundPage,
        },
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js